import { ProductSearchInputSkeleton } from '@atlassian/product-search-dialog/skeleton';
import React, { Suspense } from 'react';

import ErrorBoundary from '../../../ErrorBoundary/ErrorBoundary';

export const NavQuickSearchSkeleton = () => {
  return <ProductSearchInputSkeleton />;
};

const AsyncQuickSearch = React.lazy(() =>
  import(
    /* webpackChunkName: "nav-quick-search-deferred" */
    './QuickSearch'
  ),
);
export const NavQuickSearch = () => {
  return (
    <ErrorBoundary subject="quickSearch">
      <Suspense fallback={<ProductSearchInputSkeleton />}>
        <AsyncQuickSearch />
      </Suspense>
    </ErrorBoundary>
  );
};
export default NavQuickSearch;
